import { FDPPDFSettings } from '@teetsh/app/src/types/sequences';

interface Props {
  settings?: FDPPDFSettings;
  ficheDePrepId?: string;
  fieldsToDisplay?: string[];
}

export function buildFDPPDFParams({
  settings,
  ficheDePrepId,
  fieldsToDisplay,
}: Props) {
  if (!settings) {
    const params = new URLSearchParams();
    if (ficheDePrepId === undefined) {
      params.set('withFichesDePrep', 'true');
    }
    return params;
  }

  const params = new URLSearchParams({
    size: (settings.size || 14).toString(),
    breakinsideavoidphases: settings.breakInsideAvoidPhases ? 'true' : 'false',
    landscape: settings.landscape ? 'true' : 'false',
    mainTagColor: settings.mainTagColor || 'yellow-200',
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 10).toString(),
    marginBottom: (settings.marginBottom ?? 10).toString(),
    marginLeft: (settings.marginLeft ?? 10).toString(),
    marginRight: (settings.marginRight ?? 10).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  if (ficheDePrepId === undefined) {
    params.set(
      'withFichesDePrep',
      settings.withFichesDePrep ? 'true' : 'false',
    );
    params.set('onePageFdp', settings.onePageFdp ? 'true' : 'false');
  }

  params.set('listsPrintView', settings.listsPrintView || 'inline');
  params.set('phasesPrintView', settings.phasesPrintView || 'cards');
  params.set('numberThePhases', settings.numberThePhases ? 'true' : 'false');
  if (fieldsToDisplay?.length === 0) {
    // fieldsToDisplay defined but empty
    params.set('fieldsToDisplay[]', '');
  }
  fieldsToDisplay?.forEach(field => params.append('fieldsToDisplay[]', field));

  return params;
}
